import script from "./PopupWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupWindow.vue?vue&type=script&setup=true&lang=js"

import "./PopupWindow.vue?vue&type=style&index=0&id=48bb4385&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bb4385"]])

export default __exports__